import commonEnv from './environment.common';

export const environment = {
  ...commonEnv,
  /** Default base path to read from DB, e.g. projects/PLH */
  DEFAULT_PROJECT: 'PLH',
  production: true,
};
